export function mapStyles() {
  return [{
      "featureType": "all",
      "elementType": "labels.text",
      "stylers": [{
        "color": "#878787"
      }]
    },
    {
      "featureType": "all",
      "elementType": "labels.text.stroke",
      "stylers": [{
        "visibility": "off"
      }]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [{
        "color": "#f5f7f9"
      }]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [{
        "color": "#123661"
      }]
    },
    {
      "featureType": "road",
      "elementType": "labels.text",
      "stylers": [{
          "saturation": "-16"
        },
        {
          "visibility": "on"
        },
        {
          "color": "#9acb3b"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#9acb3b"
      }]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [{
        "color": "#123661"
      }]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [{
        "color": "#123661"
      }]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [{
        "color": "#c9c9c9"
      }]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text",
      "stylers": [{
        "color": "#123661"
      }]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [{
        "color": "#aee0f4"
      }]
    }
  ]
}